export const GP_OMS_SPEND_COLUMN_TITLE = 'OMS Spend (auto, ex VAT)'

export const GP_OMS_SPEND_COLUMN_TOOLTIP =
  'Actual supplier spend through OMS on this date, excluding VAT. If goods were receipted, the receipted values are used.'

export const GP_OMS_SPEND_AVG_TOOLTIP =
  'Average daily OMS spend (automatic supplier spend) for this period, excluding VAT.'

export const GP_OMS_SPEND_TOTAL_LABEL = 'Total OMS Spend (ex VAT):'

export const GP_EXCLUDED_THIS_PERIOD_TOOLTIP =
  'Shopping-list products ticked Exclude from gross profit that had OMS spend in this period. That spend is left out of OMS Spend and GP%.'

export function formatGpExcludedThisPeriodSummary(
  excludedThisPeriod,
  { formatSpend } = {},
) {
  const productCount = Number(excludedThisPeriod?.productCount) || 0
  if (productCount <= 0) return null

  const spend = Number(excludedThisPeriod?.spend)
  const amount = Number.isFinite(spend) ? spend : 0
  const spendText = formatSpend ? formatSpend(amount) : `£${amount.toFixed(2)}`
  const products =
    productCount === 1
      ? '1 product excluded'
      : `${productCount} products excluded`

  return `${products} · ${spendText} out of purchases`
}
